import BuildingControls from 'components/buildingsidebar/building-controls';
import RunningTotal from 'components/runningtotal/running-total';
import { useSmallScreen } from 'helpers/isSmallScreen';
import React from 'react';

const BuildSheet: React.FunctionComponent = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div
      style={{
        justifyContent: 'space-between',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: Theme['@grey-lightest'],
      }}
    >
      <BuildingControls />
      {!isSmallScreen && <RunningTotal />}
    </div>
  );
};

export default BuildSheet;
